import {
  Button,
  Drawer,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useMemo, useState } from "react";
import { Box } from "@mui/system";
import { bool, func, object } from "prop-types";
import { useSnackbar } from "notistack";
import { useAddDataLimit, useUpdateDataLimit } from "@/hooks";
import { useTextDomainContext } from "@/app/providers";
import { DateUnitDropDown, KeyTextField } from "@/components";
import { createKey } from "@/utils";
import { DropdownOption } from "@/types/Dropdown.types";

// const months = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
//
// const years = Array.from(
//   { length: 10 },
//   (_, i) => new Date().getFullYear() - i,
// );

interface AddDataLimitRow {
  Id?: string | number;
  key?: string;
  name?: string;
  climate?: {
    type?: string;
    units?: number;
  };
  consumption?: {
    type?: string;
    units?: number;
  };
  procurement?: {
    type?: string;
    units?: number;
  };
  statement?: {
    units?: number;
  };
  statementType?: string;
}

interface AddDataLimitProps {
  open?: boolean;
  row?: AddDataLimitRow;
  handleClose: (open: boolean) => void;
}

export const AddDataLimit = (props: AddDataLimitProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const open = useMemo(() => {
    return props.open || false;
  }, [props.open]);

  //#region useState
  // const statementType = "year";
  // const propsDefault = {
  //   open: false,
  // };

  // const [open, setOpen] = useState(
  //   typeof props.open !== "undefined" ? props.open : propsDefault.open,
  // );

  const [newRow, setNewRow] = useState({
    name: "",
    key: "",
    climateType: "month",
    climateUnits: 0,
    consumptionType: "month",
    consumptionUnits: 0,
    procurementType: "month",
    procurementUnits: 0,
    statementUnit: 0,
    statementType: "year",
  });

  // const [newName, setNewName] = useState("");
  // const [newKey, setNewKey] = useState("");
  // const [climateType, setClimateType] = useState(
  //   props?.row?.climate?.type ? props.row.climate.type : "month",
  // );
  // const [consumptionType, setConsumptionType] = useState(
  //   props?.row?.consumption?.type ? props.row.consumption.type : "month",
  // );
  // const [procurementType, setProcurementType] = useState(
  //   props?.row?.procurement?.type ? props.row.procurement.type : "month",
  // );
  // const [climateUnits, setClimateUnits] = useState(0);
  // const [consumptionUnits, setConsumptionUnits] = useState(0);
  // const [procurementUnits, setProcurementUnits] = useState(0);
  // const [statementUnit, setStatementUnit] = useState(0);
  //#endregion useState

  const row = useMemo(() => {
    return {
      name: props?.row?.name || newRow.name,
      key: props?.row?.key || newRow.key,
      climateType: props?.row?.climate?.type || newRow.climateType,
      climateUnits: props?.row?.climate?.units || newRow.climateUnits,
      consumptionType: props?.row?.consumption?.type || newRow.consumptionType,
      consumptionUnits:
        props?.row?.consumption?.units || newRow.consumptionUnits,
      procurementType: props?.row?.procurement?.type || newRow.procurementType,
      procurementUnits:
        props?.row?.procurement?.units || newRow.procurementUnits,
      statementUnit: props?.row?.statement?.units || newRow.statementUnit,
      statementType: props?.row?.statementType || newRow.statementType,
    };
  }, [newRow, props.row]);

  // const name = useMemo(() => {
  //   return newName || props.row.name || "";
  // }, [newName, props.row.name]);
  //
  // const key = useMemo(() => {
  //   return newKey || props.row.key || "";
  // }, [newKey, props.row.key]);

  //#region useCallback
  const resetForm = useCallback(() => {
    setNewRow({
      name: "",
      key: "",
      climateType: "month",
      climateUnits: 0,
      consumptionType: "month",
      consumptionUnits: 0,
      procurementType: "month",
      procurementUnits: 0,
      statementUnit: 0,
      statementType: "month",
    });
  }, []);

  const handleClose = () => {
    props.handleClose(false);
  };
  //#endregion useCallback

  //#region Hooks
  const { addDataLimit, loading: updatingAdd } = useAddDataLimit(
    () => {
      resetForm();
      handleClose();
      enqueueSnackbar(gettext("The historical data limit has been added."), {
        variant: "success",
      });
    },
    (error) => {
      enqueueSnackbar(
        gettext("Error: Something went wrong!" + " " + error.toString()),
        {
          variant: "error",
        },
      );
    },
  );

  const { updateDataLimit, loading: updatingEdit } = useUpdateDataLimit(
    () => {
      resetForm();
      handleClose();
      enqueueSnackbar(gettext("The data limit has been updated"), {
        variant: "success",
      });
    },
    (error) => {
      enqueueSnackbar(
        gettext("Error: Something went wrong!" + " " + error.toString()),
        {
          variant: "error",
        },
      );
    },
  );
  //#endregion Hooks

  //#region useEffect
  // useEffect(() => {
  //   if (typeof props.open !== "undefined") {
  //     setOpen(props.open);
  //   }
  // }, [props.open]);

  // useEffect(() => {
  //   if (props.row.key) {
  //     // setName(props.row.name);
  //     // setKey(props.row.key);
  //     setClimateType(props.row.climate.type);
  //     setClimateUnits(props.row.climate.units || 0);
  //     setConsumptionType(props.row.consumption.type);
  //     setConsumptionUnits(props.row.consumption.units || 0);
  //     setProcurementType(props.row.procurement.type);
  //     setProcurementUnits(props.row.procurement.units || 0);
  //     setStatementUnit(props.row.statement.units || 0);
  //   } else {
  //     // setName("");
  //     // setKey("");
  //     setClimateType("month");
  //     setClimateUnits(0);
  //     setConsumptionType("month");
  //     setConsumptionUnits(0);
  //     setProcurementType("month");
  //     setProcurementUnits(0);
  //     setStatementUnit(0);
  //   }
  // }, [props.row]);
  //#endregion useEffect

  //#region Handlers
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const variables: any = {
      key: row.key,
      name: row.name,
      climate_type: row.climateType,
      climate_units: row.climateUnits,
      consumption_type: row.consumptionType,
      consumption_units: row.consumptionUnits,
      procurement_type: row.procurementType,
      procurement_units: row.procurementUnits,
      statement_type: row.statementType,
      statement_units: row.statementUnit,
    };
    if (props.row.key) {
      variables.dataLimitId = props.row.Id;
      updateDataLimit({
        variables: variables,
        refetchQueries: ["DataLimitList"],
      }).then();
    } else {
      addDataLimit({
        variables: variables,
        refetchQueries: ["DataLimitList"],
      }).then();
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewRow({
      ...newRow,
      name: event.target.value,
      key: createKey(event.target.value),
    });
  };

  const handleKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewRow({
      ...newRow,
      key: createKey(event.target.value),
    });
  };

  const handleClimateTypeChange = (event: DropdownOption) => {
    setNewRow({
      ...newRow,
      climateType: createKey(String(event.value)),
    });
  };

  const handleConsumptionTypeChange = (event: DropdownOption) => {
    setNewRow({
      ...newRow,
      consumptionType: createKey(String(event.value)),
    });
  };

  const handleProcurementTypeChange = (event: DropdownOption) => {
    setNewRow({
      ...newRow,
      procurementType: createKey(String(event.value)),
    });
  };

  const handleClimateUnitsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const climateUnits = Number.isNaN(event.target.valueAsNumber)
      ? 0
      : event.target.valueAsNumber;
    setNewRow({
      ...newRow,
      climateUnits,
    });
  };

  const handleConsumptionUnitsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const consumptionUnits = Number.isNaN(event.target.valueAsNumber)
      ? 0
      : event.target.valueAsNumber;
    setNewRow({
      ...newRow,
      consumptionUnits,
    });
  };

  const handleProcurementUnitsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const procurementUnits = Number.isNaN(event.target.valueAsNumber)
      ? 0
      : event.target.valueAsNumber;
    setNewRow({
      ...newRow,
      procurementUnits,
    });
  };

  const handleStatementUnitChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const statementUnit = Number.isNaN(event.target.valueAsNumber)
      ? 0
      : event.target.valueAsNumber;
    setNewRow({
      ...newRow,
      statementUnit,
    });
  };

  //#endregion Handlers

  return (
    <Drawer
      anchor={"right"}
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
      slotProps={{
        paper: {
          sx: {
            padding: 4,
            maxWidth: 450,
          },
        },
      }}
    >
      <Box
        sx={{
          width: "auto",
        }}
      >
        <form onSubmit={submitHandler}>
          <Stack
            spacing={4}
            sx={{
              height: "100%",
            }}
          >
            <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
              {!props.row.key && gettext("Create Historical Data Limit")}
              {props.row.key && gettext("Edit Historical Data Limit")}
            </Typography>

            <Box
              sx={{
                height: "100%",
              }}
            >
              <Grid container spacing={4} sx={{ width: "100%" }}>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    type="text"
                    label={gettext("Name")}
                    placeholder={gettext("Name")}
                    size="small"
                    required
                    fullWidth
                    value={row.name}
                    onChange={handleNameChange}
                  />
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <KeyTextField
                    type="text"
                    label={gettext("Key")}
                    placeholder={gettext("Alpha numeric and dash only")}
                    size="small"
                    required
                    fullWidth
                    value={row.key}
                    onChange={handleKeyChange}
                    disabled={!!props.row.key}
                  />
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      lineHeight: 3,
                    }}
                  >
                    {gettext("Consumption")}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography>Current</Typography>
                    <DateUnitDropDown
                      defaultValue={row.consumptionType}
                      visualStyle="autoComplete"
                      onChange={handleConsumptionTypeChange}
                    />
                    <Typography>+</Typography>

                    <TextField
                      // label="Number"
                      type="number"
                      value={row.consumptionUnits}
                      onChange={handleConsumptionUnitsChange}
                      size="small"
                      sx={{
                        width: 75,
                      }}
                    />
                    <Typography>Months</Typography>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      lineHeight: 3,
                    }}
                  >
                    {gettext("Climate")}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography>Current</Typography>
                    <DateUnitDropDown
                      defaultValue={row.climateType}
                      visualStyle="autoComplete"
                      onChange={handleClimateTypeChange}
                    />
                    <Typography>+</Typography>

                    <TextField
                      // label="Number"
                      type="number"
                      value={row.climateUnits}
                      onChange={handleClimateUnitsChange}
                      size="small"
                      sx={{
                        width: 75,
                      }}
                    />
                    <Typography>Months</Typography>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      lineHeight: 3,
                    }}
                  >
                    {gettext("Procurement")}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography>Current</Typography>
                    <DateUnitDropDown
                      defaultValue={row.procurementType}
                      visualStyle="autoComplete"
                      onChange={handleProcurementTypeChange}
                    />
                    <Typography>+</Typography>

                    <TextField
                      // label="Number"
                      type="number"
                      value={row.procurementUnits}
                      onChange={handleProcurementUnitsChange}
                      size="small"
                      sx={{
                        width: 75,
                      }}
                    />
                    <Typography>Months</Typography>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      lineHeight: 3,
                    }}
                  >
                    {gettext("Statement Export")}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography>Current Year + </Typography>
                    <TextField
                      // label="Number"
                      type="number"
                      value={row.statementUnit}
                      onChange={handleStatementUnitChange}
                      size="small"
                      sx={{
                        width: 75,
                      }}
                    />
                    <Typography>Year</Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    Note:{" "}
                  </Typography>
                  <Typography variant="body1" sx={{}}>
                    {gettext(
                      "If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.",
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Paper elevation={0}>
              <Grid container spacing={4} sx={{ width: "100%" }}>
                <Grid size={{ xs: 6 }} sx={{ textAlign: "center" }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleClose()}
                  >
                    {gettext("Cancel")}
                  </Button>
                </Grid>

                <Grid size={{ xs: 6 }} sx={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    loading={updatingAdd || updatingEdit}
                    fullWidth
                    type="submit"
                  >
                    {gettext("Save")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Stack>
        </form>
      </Box>
    </Drawer>
  );
};

AddDataLimit.propTypes = {
  open: bool,
  handleClose: func,
  row: object,
};
